import React, { useEffect, useState } from "react";
import VerificationVKYCService from "./VerificationVKYCService";
import { IVKYCDataPayload, TAB_TYPE } from "./VerificationVKYC.types";
import {
  apiResponseMiddleware,
  checkSectionEditability,
  checkVisibility,
  getVisibleAndEditableFieldsConfig
} from "src/services/ApiResponseMiddleware";
import DetailsSection from "src/components/composed/DetailsSection/DetailsSection";
import DocumentComponentWrapper from "src/components/composed/DocumentComponent";
import { TAB_ACTIONS } from "src/shared/utils/constants";

const VerificationVKYC = (data: IVKYCDataPayload) => {
  const {
    token,
    loanApplicationID,
    pageName,
    userID,
    tabType,
    isLenderDashboard = true,
    configResponse: configResponseFronProps
  } = data;
  const [formFields, setFormFields] = useState<any>(
    getVisibleAndEditableFieldsConfig(
      apiResponseMiddleware(configResponseFronProps)
    )
  );
  const [configResponse, setConfigResponse] = useState<any>(
    configResponseFronProps
  );

  const fetchVKYCData = async () => {
    let response: any;
    const payload = {
      token,
      loanApplicationID,
      pageName,
      userID,
      isLenderDashboard
    };
    if (tabType === TAB_TYPE.VKYC) {
      response = await VerificationVKYCService.getVKYCData({ ...payload });
    } else if (tabType === TAB_TYPE.VPD) {
      response = await VerificationVKYCService.getVideoPDData({ ...payload });
    }

    if (response?.status) {
      const formFields = getVisibleAndEditableFieldsConfig(
        apiResponseMiddleware(response)
      );
      const configResponse = response?.data;
      setConfigResponse(configResponse);
      setFormFields(formFields);
    } else {
      console.error(response?.error);
    }
  };

  useEffect(() => {
    !configResponseFronProps && fetchVKYCData();
  }, [tabType]);

  const renderDocumentCategory = (categoryKey: string, category: any) => {
    const documents = category?.documents || category?.docList || [];
    if (documents.length === 0) return null;

    return (
      <div key={categoryKey} className="mt-4">
        {category?.label && (
          <h3 className="text-sm text-black font-medium w-max border-b-2 border-indigo-500 py-2 pr-2 mb-4">
            {category.label}
          </h3>
        )}
        <div className="mt-4 flex flex-wrap -mb-2">
          {documents.map((document: any, docIndex: number) => {
            const isDocumentVisible = checkVisibility(document);
            if (!isDocumentVisible) return null;
            const configRuleData = configResponse?.data?.ruleData;
            return (
              <DocumentComponentWrapper
                key={
                  document?.id ||
                  document?.documentID ||
                  `${categoryKey}-${docIndex}`
                }
                doc={document}
                reloadParent={() => fetchVKYCData()}
                token={token}
                loanID={loanApplicationID}
                isEditable={
                  configRuleData?.tabPermissions?.features?.[
                    TAB_ACTIONS.SCREENING_STATUS_DROPDOWN
                  ]?.isVisible || false
                }
                pageName={pageName}
                isLenderDashboard={true}
                isAdditionalDocs={true}
                permissions={configRuleData?.pagePermission || {}}
                loanDetails={configResponse?.data?.loanDetails || {}}
                isMFL_LAP={false}
                isback={false}
                tabPermissions={configRuleData?.tabPermissions || {}}
                documentScreeningOptions={
                  configRuleData?.documentScreeningOptions || {}
                }
                mediaMetaData={document?.mediaMetaData}
                mediaID={document?.mediaID}
              />
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      {formFields?.sections
        ?.slice()
        ?.sort((a: any, b: any) => a.sectionSequence - b.sectionSequence)
        ?.map((section: any, index: number) => (
          <DetailsSection
            accordion={true}
            key={section?.id}
            isFirstSection={index === 0}
            isEditable={checkSectionEditability(section)}
            title={section?.label}
            renderUIConfig={true}
            items={section?.fieldList}
            pageName={pageName}
            token={token}
            tabName={"vkyc_tab"}
            isLenderPlatform={true}
            resourceName={"vkyc_tab"}
            sectionID={section?.id}
            sectionData={section || {}}
            onDataRefresh={fetchVKYCData}
            graphQLResponse={{
              ...configResponse?.data?.ruleData?.graphQLResponse
            }}
            uiElements={configResponse?.data?.ruleData?.uiElements}
            loanApplicationID={loanApplicationID}
            sectionButtons={section.buttonList}
          />
        ))}

      {Object.entries(
        formFields?.documentSection || formFields?.documents || {}
      ).map(([categoryKey, category]: [string, any]) =>
        renderDocumentCategory(categoryKey, category)
      )}
    </>
  );
};

export default VerificationVKYC;
